import { getAlertIdentifier } from '../../utils/alertData.utils';
import { getVisibleForecastAdvisories } from '../../utils/forecastAdvisories.utils';
import { FORECAST_ADVISORY_MODES } from '../../config/forecastAdvisories.config';
import ForecastAdvisory from '../ForecastAdvisory/ForecastAdvisory';

const ForecastAdvisoryList = ({ alerts, mode, maximumDistanceMiles }) => {
  const visibleAdvisories = getVisibleForecastAdvisories(alerts, {
    mode,
    maximumDistanceMiles,
  });

  if (!visibleAdvisories.length) {
    const message =
      mode === FORECAST_ADVISORY_MODES.local
        ? `No active advisories were found within ${maximumDistanceMiles} miles.`
        : 'No active NWS advisories are available right now.';

    return (
      <p className="m-3" role="status">
        {message}
      </p>
    );
  }

  return visibleAdvisories.map((alert, index) => (
    <ForecastAdvisory alert={alert} key={getAlertIdentifier(alert, index)} />
  ));
};

export default ForecastAdvisoryList;
